import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { connectRouter } from "connected-react-router";
import {reducer as oidcReducer} from "redux-oidc";
import * as WorkOrders from "./WorkOrder";
import * as Invoices from "./Invoice";
import * as KPI from "./KPI";
import * as Locations from "./Location";
import * as LocationDetail from "./LocationDetail";
import * as Quotes from "./Quote";
import * as Breadcrumbs from "./Breadcrumbs";
import * as Logout from "./Logout";
import * as Admin from "./Admin";

export default function configureStore(history, initialState) {
  const reducers = {
    oidc: oidcReducer,
    admin: Admin.reducer,
    kpi: KPI.reducer,
    workorders: WorkOrders.reducer,
    locations: Locations.reducer,
    locationDetail: LocationDetail.reducer,
    invoices: Invoices.reducer,
    quotes: Quotes.reducer,
    breadcrumbs: Breadcrumbs.reducer,
    router: connectRouter(history),
    boolLogout: Logout.reducer
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const rootReducer = combineReducers({
    ...reducers,
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
